/** @jsx jsx */
import { FC } from "react";
import { jsx } from "theme-ui";

import { EntityType } from "@/core/types";
import { RelatedEntities } from "@/data/related";
import { RelatedJobRequestsList } from "@/views/related/_components/RelatedJobRequestsList";

import { RelatedAssignmentsList } from "./RelatedAssignmentsList";
import { useRelatedEntitiesNav } from "./RelatedEntitiesNavContext";
import { RelatedWorkersList } from "./RelatedWorkersList";

interface RelatedEntitiesListProps {
  relatedEntities: RelatedEntities;
  entityType: EntityType;
  entityId: string | number;
}

export const RelatedEntitiesList: FC<RelatedEntitiesListProps> = ({ relatedEntities, ...restProps }) => {
  const { activeTab } = useRelatedEntitiesNav();
  const url = relatedEntities.urls[activeTab]!;

  const commonProps = { ...restProps, url };

  switch (activeTab) {
    case "assignment":
      return <RelatedAssignmentsList {...commonProps} />;
    case "worker":
    case "candidate":
      return <RelatedWorkersList entityKey={activeTab} {...commonProps} />;
    case "job-request":
      return <RelatedJobRequestsList {...commonProps} />;
    default:
      throw new Error("RelatedEntityKey cannot be recognized");
  }
};
